import { createTheme, alpha } from '@mui/material/styles'



const theme = createTheme({
    typography: {
        fontFamily: [
            'objektiv-mk3',
            'sans-sarif'
        ].join(','),

        button: {
            fontFamily: 'co-headline, sans-sarif',
            fontWeight: 400
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1140,
            xl: 1536
        }
    },
    palette: {
        primary: {
            main: '#0a717c'
        },
        secondary: {
            main: '#0a717c',
            contrastText: '#fff'
        },
        
    }


});

theme.components = {

    MuiCheckbox: {
        styleOverrides:{
            colorPrimary: {
            
                border:'100px'
            }
        }
    },

    // uncomment for evergabe main cpv-search and comment nexct block
    //  MuiInputBase: {
    // styleOverrides:{
    //         input: {
    //   '&::placeholder': {
    //     color: '#8a8a8a',
    //     opacity: 1,
    //   },
    //   color: '#8a8a8a', 
    // }
    // }
    // },

    MuiInputBase: {
    styleOverrides:{
            input: {
      '&::placeholder': {
        color: '#8a8a8a',
        opacity: 1,
        fontSize:"1em",
      },
      color: '#8a8a8a', 
      fontSize:"1em",
    }
    }
    },


    MuiDialogTitle: {
        styleOverrides: {
            root: {
                color: '#156384',
                fontSize: '2em',
                fontFamily: 'co-headline, sans-sarif',
                padding: '1.25em'
            }
        }
    },
    MuiDialogActions: {
        styleOverrides:{
            root: {
                padding: '20px'
            }
        }
    },
    MuiDivider:{
        styleOverrides:{
            root:{
                borderBottomWidth: '2px',
                borderColor: alpha('#fff', 1),
                marginBottom: '3em'
            }
        }
    },

    MuiFormControlLabel: {
        styleOverrides: {
            label: {
                color: alpha('#fff', 0.5),

                a: {
                    color: alpha('#fff', 0.5),
                }
            }
        }
    },

    MuiSelect: {
        styleOverrides: {
            iconOutlined: {
                color: alpha('#fff', 0.5)
            }
        }
    },
    MuiPaper: {
        styleOverrides: {
      root: {
        marginTop: '2px'
      }
    }
    },

    MuiTypography: {
        styleOverrides: {
            root: {
                fontFamily: 'objektiv-mk3, sans-sarif',
                lineHeight: '1.75em'
            },
            smWhite: {
                [theme.breakpoints.down('md')]: {
                    color: '#e9e9e9',
                },
                [theme.breakpoints.up('md')]: {
                    color: '#e9e9e9',
                },
            },
            h1: {
                [theme.breakpoints.down('md')]: {
                    fontSize: '2.25em',
                },
                [theme.breakpoints.up('md')]: {
                    fontSize: '3em',
                },

                fontFamily: 'co-headline, sans-sarif',
                lineHeight: '1.188em',
                color: '#EDC997'

            },
            h2: {
                fontSize: '1.5em',
                fontFamily: 'co-headline, sans-sarif',
                color: '#EDC997'

            },

            h4: {
                fontSize: '1.125em',
                marginBottom: '24px',
                fontFamily: 'co-headline, sans-sarif',
                lineHeight: '1.188em',


                [theme.breakpoints.down('md')]: {
                    color: '#e9e9e9',
                },
                [theme.breakpoints.up('md')]: {
                    color: '#e9e9e9',
                },

            },

        }
    },



    MuiButton: {
        defaultProps: {
            disableElevation: true,
            disableFocusRipple: true,
            disableRipple: true
        },
        styleOverrides: {
            root: {
                color: '#fff',
                border: '1px solid #fff',
                borderRadius: 12,
                borderWidth: 2,
                backgroundColor: '#0a717c',
                fontSize: '1.375em',
                paddingTop: '8px',
                paddingBottom: '8px',
                paddingLeft: '30px',
                paddingRight: '30px',
                lineHeight: '28px',
                textTransform: "none",

                '&:hover': {
                    borderWidth: 2,
                    color: '#0a717c',
                    backgroundColor: '#fff',
                    borderColor: '#0a717c',
                }

            }
        },

    },

    MuiContainer: {
        defaultProps: {
            disableGutters: true,
        }
    }
}

export default theme;